function Up({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '18'} height=${dimensions || '18'} viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.59 7.70502L6 3.12502L1.41 7.70502L0 6.29502L6 0.295017L12 6.29502L10.59 7.70502Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Up;
